
import axios from "./settingInstance"
import addSetting from "@/services/Settings/addSetting";
import { notifyOnboardingStatusChanged } from '@/features/onboarding/events'

export default async ({value, key}: {value: any, key:string}) => {
    const payload ={
        "value":value
    };

    try {
        const response: any = await axios.put(`/settings/${key}`, payload);
        notifyOnboardingStatusChanged()
        return response.data
    } catch (error) {
        return error
    }
}
